"use strict";

// This measures how tall the page header is, and saves that number as --hdr-h so other CSS can use it
// (so sticky/scrolled-to content doesn't end up hidden behind the header).

/* Don't do this while someone is editing the page in Sitecore */
if (!document.querySelector("body").classList.contains("isEditing")) {

	const hdr = document.querySelector(".hdr");
	if (hdr) {
		// Measure once immediately, so we have a value right away (not just once the check below reacts)
		document.documentElement.style.setProperty("--hdr-h", `${hdr.getBoundingClientRect().height}px`);

		// Also keep watching the header, and re-measure whenever its size changes (eg window resize)
		new ResizeObserver(entries => {
			for (const entry of entries) {
				// small delay before updating, just to avoid a harmless browser warning
				requestAnimationFrame(() => {
					document.documentElement.style.setProperty("--hdr-h", `${entry.contentRect.height}px`);
				})
			}
		}).observe(hdr);
	}

}
